// Import Operations
import calcFields from './calculated/calcFields.js';
import getData from './getData/getData.js';
import resetData from './reset/resetData.js';
import reCalc from './reCalc/reCalc.js';

// Import Configuration
import fieldsLogicData from '../model/logic/fieldsLogicData.js';

const runFieldsLogic = async (data, entity, fields, prevData) => {
    let processedData = { ...data }

    if (!fieldsLogicData[entity]) return processedData

    if (!fields) {
        console.warn('WARNING : Missing fieldsLogic property on cardViewData')
        return processedData
    }

    if (fieldsLogicData[entity]) {
        const config = fieldsLogicData[entity]

        // Process each field sequentially to properly handle async operations
        for (const field of fields) {
            let fieldConfig = undefined;

            if (config[field] !== undefined) {
                fieldConfig = config[field]
            }

            if (fieldConfig) {
                for (const operation of fieldConfig) {
                    if (operation.logicType === 'calcFields') {
                        processedData = calcFields(processedData, operation, prevData)
                    } else if (operation.logicType === 'getData') {
                        // Use await to properly wait for async operations
                        processedData = await getData(processedData, operation, prevData)
                    } else if (operation.logicType === 'reset') {
                        // Use await to properly wait for async operations
                        processedData = resetData(processedData, operation, prevData)
                    } else if (operation.logicType === 'reCalc') {
                        // Use await to properly wait for async operations
                        processedData = await reCalc(processedData, operation, prevData)
                    } else if (operation.logicType === 'other') {
                        // Handle other operation types if needed
                    }
                }
            }
        }
    }

    return processedData
}

export default runFieldsLogic
